import { Snackbar, Alert } from '@mui/material';

const WidgetAlert = ({ open, type, message, onClose }) => (
    <Snackbar open={open} autoHideDuration={3000} onClose={onClose}>
        <Alert severity={type} onClose={onClose} variant="filled">
            {message}
        </Alert>
    </Snackbar>
);

export default WidgetAlert;
